function disableScroll() {
    var scrollPosition = [
        self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
        self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    ];
    var html = $('html'); // it would make more sense to apply this to body, but IE7 won't have that
    html.attr('scroll-position', scrollPosition);
    html.attr('previous-overflow', html.css('overflow'));
    html.attr('previous-touch-action', html.css('touch-action'));
    html.css('overflow', 'hidden');
    html.css('touch-action', 'pan-x pan-y');
}

function enableScroll() {
    var html = $('html');
    var scrollPosition = html.attr('scroll-position').split(',');
    html.css('overflow', html.attr('previous-overflow'));
    html.css('touch-action', html.attr('previous-touch-action'));
    window.scrollTo(scrollPosition[0], scrollPosition[1]);
}